import React, { ReactNode } from "react";
import SwipeableBottomSheet from "react-swipeable-bottom-sheet";
import { CSSProperties } from "styled-components";

const ReactSwipeableBottomSheet = (props: SwipeableBottomSheetProps) => {
    return <SwipeableBottomSheet {...props} />;
};

export default ReactSwipeableBottomSheet;

interface SwipeableBottomSheetProps {
    bodyStyle?: CSSProperties;
    children: ReactNode;
    defaultOpen?: boolean;
    fullScreen?: boolean;
    marginTop?: number;
    onChange?: (open: boolean) => void;
    onTransitionEnd?: () => void;
    open?: boolean;
    overflowHeight?: number;
    overlay?: boolean;
    overlayStyle?: CSSProperties;
    scrollTopAtClose?: boolean;
    shadowTip?: boolean;
    style?: CSSProperties;
    swipeableViewsProps?: SwipeableViewsProps;
    topShadow?: boolean;
}

interface SwipeableViewsProps {
    action?: () => void;
    animateHeight?: boolean;
    animateTransitions?: boolean;
    axis?: "x" | "x-reverse" | "y" | "y-reverse";
    children?: ReactNode;
    containerStyle?: CSSProperties;
    disabled?: boolean;
    disableLazyLoading?: boolean;
    enableMouseEvents?: boolean;
    hysteresis?: number;
    ignoreNativeScroll?: boolean;
    index?: number;
    onChangeIndex?: (index: number, indexLatest: number, meta: object) => void;
    onMouseDown?: () => void;
    onMouseLeave?: () => void;
    onMouseMove?: () => void;
    onMouseUp?: () => void;
    onScroll?: () => void;
    onSwitching?: (index: number, type: "move" | "end") => void;
    onTouchEnd?: () => void;
    onTouchMove?: () => void;
    onTouchStart?: () => void;
    onTransitionEnd?: () => void;
    resistance?: boolean;
    slideClassName?: string;
    slideStyle?: CSSProperties;
    springConfig?: {
        delay?: string;
        duration?: string;
        easeFunction?: string;
    };
    style?: CSSProperties;
    threshold?: number;
}
